export const UINT32_MAX = 0xffffffff;
export const UINT32_RANGE = 0x100000000;
